import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { environment } from '$environments/environment'
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  clients!: MatTableDataSource<any>;
  paginatorSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  filterValue: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.http.get<any[]>(`${environment.apiUrl}/rest/users/details`).subscribe(data => {
      this.clients = new MatTableDataSource<any>(data);
      this.clients.paginator = this.paginator;
      this.clients.sort = this.sort;
    });
  }


  applyFilter(value: string) {
    this.clients.filter = value.trim().toLowerCase();
  }



}
